import { createRef, useEffect, useState } from 'react';

import { Flex } from '@chakra-ui/react';

import { isMobileView } from 'constants/isMobileView';

const ScrollableQuestionnaire = ({ comps = [], selectedCompId = null }) => {
  const [compRefs, setCompRefs] = useState({});

  const scrollToComponentTop = (id) => {
    compRefs[id].current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    setCompRefs((refs) => {
      const newRefObj = {};
      comps.forEach(({ id }) => {
        newRefObj[id] = refs[id] || createRef();
      });
      return newRefObj;
    });
  }, [comps]);

  useEffect(() => {
    if (selectedCompId && compRefs[selectedCompId]) {
      scrollToComponentTop(selectedCompId);
    }
  });

  return (
    <Flex
      style={{
        flexDirection: 'column',
        alignItems: 'stretch',
        flexGrow: 1,
        height: '100%',
        overflow: 'hidden',
        width: '100%',
        padding: isMobileView() ? '0px' : '16px',
      }}
      onScroll={(e) => e.stopPropagation()}
    >
      {comps.map(({ id, comp }) => (
        <Flex
          style={{
            minHeight: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          ref={compRefs[id]}
          key={id}
        >
          {comp}
        </Flex>
      ))}
    </Flex>
  );
};

export { ScrollableQuestionnaire };
